export default __webpack_public_path__ + "static/media/640_private01-nl-web.7ba7cf64.png";